import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generatePath } from 'react-router-dom';
import {
  API_ASSET_MAPPING_FILE_DESTINATION,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_MAPPING_FILE_DESTINATION,
} from '../constants';

const api = (filePath) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_ASSET_MAPPING_FILE_DESTINATION, { filePath }),
  });

const assetMappingFileDestination = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_MAPPING_FILE_DESTINATION,
  responseMapping: ResponseMapping.Default,
});

export default assetMappingFileDestination;
